import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import ClientAvatar from '@components/ClientAvatar';
import styles from '@components/forms/careProfile/CareProfile.module.css';
import Nbsp from '@components/Nbsp';
import CareTeamInvitePopover from '@components/profile/CareTeamInvitePopover';
import BodyCopy from '@components/typography/BodyCopy';
import useOpener from '@hooks/useOpener';
import { GetJourneyWithCareProfileQuery } from '@typing/Generated';

type Props = {
  careTeamInviteId: string | null | undefined;
  journey: GetJourneyWithCareProfileQuery['journey'];
  onCancel: (id: string | null | undefined) => void;
};

const CareProfileInvitee = ({ careTeamInviteId, journey, onCancel }: Props) => {
  const careTeamInvite = useMemo(
    () => journey.careTeamInvites?.find(invite => invite.id === careTeamInviteId),
    [careTeamInviteId, journey.careTeamInvites]
  );

  const popoverOpener = useOpener();

  return (
    <div className={`${styles.careTeamMemberRow}`}>
      {careTeamInvite && (
        <div className={styles.spreadRow}>
          <div className={styles.avatarAndName}>
            <ClientAvatar
              bold
              clientId={null}
              color="neutral100"
              firstName={careTeamInvite.email}
              fontSize={20}
              journeyId={null}
              size={30}
            />
            <BodyCopy color="neutral500">
              {careTeamInvite.email} <Nbsp /> <FormattedMessage id="pages.profile.pending" />
            </BodyCopy>
          </div>
          <div>
            <CareTeamInvitePopover
              careTeamInvite={careTeamInvite}
              onCancel={() => onCancel(careTeamInviteId)}
              opener={popoverOpener}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CareProfileInvitee;
